
import { getOrientation } from '@/lib/vendor/exifOrientation';

export default {
  name: 'AppImage',
  props: {
    background: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    frame: {
      type: String,
      default: 'sharp',
      validator: v => ['sharp', 'rounded', 'circle'].includes(v)
    },
    borderRadius: {
      type: Number,
      default: 4
    },
    shape: {
      type: String,
      default: 'original',
      validator: v =>
        ['original', 'square', 'original-in-square', 'vertical'].includes(v)
    },
    width: { type: Number, default: 0 },
    height: { type: Number, default: 0 },
    fullWidth: { type: Boolean, default: false }
  },
  data() {
    return {
      isReady: false,
      rotation: 0
    };
  },
  computed: {
    backgroundImageStyle() {
      if (!this.background) return null;
      return { backgroundImage: `url("${this.src}")`, backgroundSize: 'cover' };
    },
    requiresOrientationCheck() {
      return /^data:/.test(this.src);
    },
    styleProp() {
      let currentBorderRadius;
      switch (this.frame) {
        case 'rounded':
          currentBorderRadius = `${this.borderRadius}px`;
          break;
        case 'circle':
          currentBorderRadius = '100%';
          break;
        default:
          currentBorderRadius = '0';
      }
      return { '--border-radius': currentBorderRadius };
    },
    imageFileName() {
      return this.src.split('/').slice(-1)[0];
    }
  },
  watch: {
    isReady() {
      this.checkOrientation();
    }
  },
  mounted() {
    if (this.shape === 'original') {
      this.$nextTick(() => {
        const image = this.$refs.image;
        // HACK - 안드로이드 브라우저, 모바일 강조 팝업에서 lazy loading이 안 되는 이슈 대응
        image.style.minWidth = '1px';
        image.style.minHeight = '1px';

        if (this.height && this.width) {
          image.style.height = `${(image.offsetWidth * this.height) /
            this.width}px`;
        }
      });
    }
  },
  methods: {
    checkOrientation() {
      if (!this.requiresOrientationCheck) return;

      const { image } = this.$refs;
      getOrientation(image.src).then(orientation => {
        if (!orientation) return;

        // https://www.impulseadventure.com/photo/exif-orientation.html
        if (orientation === 3) this.rotation = 180;
        else if (orientation === 6) this.rotation = 90;
        else if (orientation === 8) this.rotation = 270;
      });
    },
    load() {
      // 이미지가 load되기 전 공간을 확보하기 위해 설정한 height 값을 제거
      this.$refs.image?.style.removeProperty('height');
      this.isReady = true;
      this.$emit('load');
    }
  }
};
